import * as angular from 'angular';
import controller from './equipmentGroupRejectsGraph.controller';
import template from './equipmentGroupRejectsGraph.tpl.html';

export default angular.module('aps.directive.equipmentGroupRejectsGraph', [controller])
  .directive('apsEquipmentGroupRejectsGraph', equipmentGroupRejectsGraphDirective)
  .name;

function equipmentGroupRejectsGraphDirective() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'EquipmentGroupRejectsGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      group: '=',
      timeZoneId: '='
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/counts/equipmentGroupRejectsGraph.directive.ts